console.log("-------- Junior Gogna ---------")

const pageType = ShopifyAnalytics?.meta?.page?.pageType || gogna_page_type;
const serverPath = "https://storm.gogna.me";
const shop = Shopify.shop;
const currencyCode = ShopifyAnalytics?.meta?.currency || "USD";
const productId = ShopifyAnalytics?.meta?.product?.gid || '';

let nameTapeProduct = null;

document.addEventListener("DOMContentLoaded", () => {
  if (pageType === "product") {
    initializeNameTapeProduct();
  }
});

// function decodeHTMLEntities(str) {
//   const txt = document.createElement("textarea");
//   txt.innerHTML = str;
//   return txt.value;
// }

function getCurrencySymbol(currencyCode) {
  const currencySymbols = {
    INR: "₹", USD: "$", EUR: "€", GBP: "£", 
    JPY: "¥", CNY: "¥", AUD: "A$", CAD: "C$",
  };
  return currencySymbols[currencyCode?.toUpperCase() || "USD"] || `${currencyCode}`;
}

const currencySymbol = getCurrencySymbol(currencyCode);
function sanitizeInput(input) {
  return input
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;")
    .replace(/'/g, "&#x27;")
    .replace(/\//g, "&#x2F;")
    .replace(/,/g, '&#44;');
}

async function initializeNameTapeProduct() {


  console.log("---- Initialize name Tape Product funct () ----")
  
  try {
    const response = await fetch(`${serverPath}/api/getProducts`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        shop
      }),
    });

    if (!response.ok) throw new Error(`HTTP error! Status: ${response.status}`);
    const result = await response.json();
    
    if (result.message === "success" && result?.nameTape?.products) {
      const matchedProduct = result.nameTape.products.find(item => item.id === productId);
    
      if (matchedProduct) {
        nameTapeProduct = matchedProduct;
        createNameTapeUI();
        setupCustomAddToCart();
      }
    }
  } catch (error) {
    console.error("Error fetching name tape product:", error);
  }
}


// -----------------------------------------------------

// function createNameTapeUI() {
//   console.log("hello---------");


//   const main = document.getElementById("gogna-123")
//   if (!main || !nameTapeProduct) return;

//   const div = document.createElement("div");
//   div.className = "product-name-taps";
  
//   const nameLabel = Number(nameTapeProduct.price) === 0 
//     ? "Name" 
//     : `Name (${currencySymbol}${Number(nameTapeProduct.price).toFixed(2)})`;
  
//   const p = document.createElement("p");
//   const span = document.createElement("span");
//   span.innerText = "*";
//   span.style.color = "red";
//   p.textContent = nameLabel;
//   p.appendChild(span);

//   const input = document.createElement("input");
//   input.type = "text";
//   input.className = "name-tape-input";
//   input.id = "custom-input";
//   input.placeholder = "Enter name for tape";

//   div.appendChild(p);
//   div.appendChild(input);
//   main.appendChild(div);
// }


function createNameTapeUI() {

const main = document.getElementById("gogna-123");
if (!main || !nameTapeProduct) return;

const mainBox = document.createElement("div");
mainBox.className = "main-box";

// create 3 blocks dynamically
for (let i = 1; i <= 3; i++) {
  mainBox.appendChild(createTapBlock(i));
}


main.appendChild(mainBox);

function createTapBlock(index){
  const div = document.createElement("div");
  div.className = `product-name-taps-${index}`;
  div.style.margin = "20px 0";
  div.style.padding = "15px";
  div.style.border = "1px solid #e5e5e5";
  div.style.borderRadius = "8px";
  div.style.backgroundColor = "#fafafa";

  // Label for Name Input
  const nameLabel =
    Number(nameTapeProduct.price) === 0
      ? " Add Name"
      : `Add Name (${currencySymbol}${Number(nameTapeProduct.price).toFixed(2)})`;

  const label = document.createElement("label");
  label.className = `custom-input-${index}`
  label.style.display = "block";
  label.style.fontSize = "15px";
  label.style.fontWeight = "600";
  label.style.marginBottom = "6px";
  label.style.color = "#222";

  const span = document.createElement("span");
  // span.innerText = "*";
  // span.style.color = "red";
  label.textContent = nameLabel + " ";
  label.appendChild(span);

  // Input field
  const input = document.createElement("input");
  input.type = "text";
  input.className = `name-tape-input-${index}`;
  input.id = `custom-input-${index}`;
  input.placeholder = "Enter name ";
  input.style.width = "100%";
  input.style.padding = "10px 12px";
  input.style.border = "1px solid #ccc";
  input.style.borderRadius = "6px";
  input.style.fontSize = "14px";
  input.style.transition = "border-color 0.3s, box-shadow 0.3s";
  input.style.outline = "none";

  input.addEventListener("focus", () => {
    input.style.borderColor = "#000";
    input.style.boxShadow = "0 0 6px rgba(0,0,0,0.15)";
  });
  input.addEventListener("blur", () => {
    input.style.borderColor = "#ccc";
    input.style.boxShadow = "none";
  });

  // ✅ Label for Position Dropdown
  const positionLabel = document.createElement("label");
  positionLabel.textContent = "Select the Position";
  positionLabel.style.display = "block";
  positionLabel.style.fontSize = "15px";
  positionLabel.style.fontWeight = "600";
  positionLabel.style.marginTop = "15px";
  positionLabel.style.marginBottom = "6px";
  positionLabel.style.color = "#222";

  // Select dropdown with 3 options
  const select = document.createElement("select");
  select.className = `name-tape-select-${index}`;
  select.id = `custom-select-${index}`;
  select.style.width = "100%";
  select.style.padding = "10px 12px";
  select.style.border = "1px solid #ccc";
  select.style.borderRadius = "6px";
  select.style.fontSize = "14px";
  select.style.backgroundColor = "#fff";

  const options = ["Back", "Left Chest", "Right Chest"];
  options.forEach((opt) => {
    const option = document.createElement("option");
    option.value = opt.toLowerCase().replace(/\s+/g, "-"); // e.g. left-chest
    option.textContent = opt;
    select.appendChild(option);
  });

  // Append all elements
  div.appendChild(label);
  div.appendChild(input);
  div.appendChild(positionLabel); // 👈 Added label for dropdown
  div.appendChild(select);

  return div;
}




  // ------------------------------------------------------------------------
  // const main = document.getElementById("gogna-123");
  // if (!main || !nameTapeProduct) return;

  // const div = document.createElement("div");
  // div.className = "product-name-taps";
  // div.style.margin = "20px 0";
  // div.style.padding = "15px";
  // div.style.border = "1px solid #e5e5e5";
  // div.style.borderRadius = "8px";
  // div.style.backgroundColor = "#fafafa";

  // // Label for Name Input
  // const nameLabel =
  //   Number(nameTapeProduct.price) === 0
  //     ? " Add Name"
  //     : `Add Name (${currencySymbol}${Number(nameTapeProduct.price).toFixed(2)})`;

  // const label = document.createElement("label");
  // label.style.display = "block";
  // label.style.fontSize = "15px";
  // label.style.fontWeight = "600";
  // label.style.marginBottom = "6px";
  // label.style.color = "#222";

  // const span = document.createElement("span");
  // // span.innerText = "*";
  // // span.style.color = "red";
  // label.textContent = nameLabel + " ";
  // label.appendChild(span);

  // // Input field
  // const input = document.createElement("input");
  // input.type = "text";
  // input.className = "name-tape-input";
  // input.id = "custom-input";
  // input.placeholder = "Enter name ";
  // input.style.width = "100%";
  // input.style.padding = "10px 12px";
  // input.style.border = "1px solid #ccc";
  // input.style.borderRadius = "6px";
  // input.style.fontSize = "14px";
  // input.style.transition = "border-color 0.3s, box-shadow 0.3s";
  // input.style.outline = "none";

  // input.addEventListener("focus", () => {
  //   input.style.borderColor = "#000";
  //   input.style.boxShadow = "0 0 6px rgba(0,0,0,0.15)";
  // });
  // input.addEventListener("blur", () => {
  //   input.style.borderColor = "#ccc";
  //   input.style.boxShadow = "none";
  // });

  // // ✅ Label for Position Dropdown
  // const positionLabel = document.createElement("label");
  // positionLabel.textContent = "Select the Position";
  // positionLabel.style.display = "block";
  // positionLabel.style.fontSize = "15px";
  // positionLabel.style.fontWeight = "600";
  // positionLabel.style.marginTop = "15px";
  // positionLabel.style.marginBottom = "6px";
  // positionLabel.style.color = "#222";

  // // Select dropdown with 3 options
  // const select = document.createElement("select");
  // select.className = "name-tape-select";
  // select.id = "custom-select";
  // select.style.width = "100%";
  // select.style.padding = "10px 12px";
  // select.style.border = "1px solid #ccc";
  // select.style.borderRadius = "6px";
  // select.style.fontSize = "14px";
  // select.style.backgroundColor = "#fff";

  // const options = ["Back", "Left Chest", "Right Chest"];
  // options.forEach((opt) => {
  //   const option = document.createElement("option");
  //   option.value = opt.toLowerCase().replace(/\s+/g, "-"); // e.g. left-chest
  //   option.textContent = opt;
  //   select.appendChild(option);
  // });

  // // Append all elements
  // div.appendChild(label);
  // div.appendChild(input);
  // div.appendChild(positionLabel); // 👈 Added label for dropdown
  // div.appendChild(select);
  // main.appendChild(div);
  // ------------------------------------------------------------------------

}

function setupCustomAddToCart() {

  const addButton = document.querySelector('[name="add"]');
  const idInput = document.querySelector('[name="id"]');
  
  if (!addButton || !idInput) return;

  // Avoid duplicate custom button
  if (addButton.parentElement.querySelector('.custom-cart-btn')) return;

  const customBtn = addButton.cloneNode(true);
  customBtn.classList.add('custom-cart-btn');
  customBtn.type = 'button';
  addButton.classList.add('hidden');
  addButton.parentElement.appendChild(customBtn);

  customBtn.addEventListener('click', handleCustomAddToCart);
} 
async function handleCustomAddToCart() {
  const inputEl = document.querySelector('.name-tape-input-1');
  const inputEl2 = document.querySelector('.name-tape-input-2');
  const inputEl3 = document.querySelector('.name-tape-input-3');
  const selectEl = document.querySelector('.name-tape-select-1');
  const selectEl2 = document.querySelector('.name-tape-select-2');
  const selectEl3 = document.querySelector('.name-tape-select-3');

  const inputText = inputEl?.value.trim() || '';
  const inputText2 = inputEl2?.value.trim() || '';
  const inputText3 = inputEl3?.value.trim() || '';

  const selectedOption = selectEl?.value || '';
  const selectedOption2 = selectEl2?.value || '';
  const selectedOption3 = selectEl3?.value || '';

  
  const customBtn = document.querySelector('.custom-cart-btn');
  const addButton = document.querySelector('[name="add"]');
  const idInput = document.querySelector('[name="id"]');

  const obj = {};

  for (let i = 1; i <= 3; i++) {
    const inputEl = document.querySelector(`.name-tape-input-${i}`);
    const selectEl = document.querySelector(`.name-tape-select-${i}`);
    const inputValue = inputEl?.value.trim();

    if (inputValue) {
      obj[i] = {
        name: inputValue,
        selectValue: selectEl?.value || ''
      };
    }
  }

  // Remove existing error messages
  const existingError = inputEl?.parentElement?.querySelector('.input-error-msg');
  if (existingError) existingError.remove();

  // If input has value but no position selected → show error
  if (inputText.length > 0 && !selectedOption) {
    showError(selectEl, "⚠️ Please select a position.");
    return;
  }

  // If input empty, skip validation and just add normally
  if (inputText.length === 0) {
    addButton?.click();
    return;
  }

  // Show loading state
  const spinner = document.createElement('div');
  spinner.className = 'gogna-custom-spinner';
  customBtn.textContent = '';
  customBtn.appendChild(spinner);

  try {
    // Get current variant price
    const variants = ShopifyAnalytics.meta.product.variants;
    const selectedVariant = variants.find(v => v.id == idInput.value);
    const price = selectedVariant ? (selectedVariant.price / 100).toFixed(2) : '0.00';

    // Add hidden inputs only when input is filled
    if (inputText.length > 0) {
      addNameTapeToForm(idInput.value, price, obj);
    }

    // Trigger original add to cart
    addButton?.click();

  } catch (error) {
    console.error('Add to cart failed:', error);
    showError(inputEl, "Failed to add to cart. Please try again.");
  } finally {
    setTimeout(() => {
      if (spinner.parentElement === customBtn) spinner.remove();
      customBtn.textContent = 'Add to cart';
    }, 300);
  }
}


function addNameTapeToForm(variantId, price, obj) {
  const productForms = document.querySelectorAll('form[action="/cart/add"]');

  productForms.forEach((form) => {
    if (!form) return;

    // Remove existing name tape properties
    form.querySelectorAll('input[name^="properties[_gid://shopify/ProductVariant/"]').forEach(input => {
      input.remove();
    });

    const fullVariantId = `gid://shopify/ProductVariant/${variantId}`;
    const inputName = `properties[_${fullVariantId}]`;
    const nameTapePrice = nameTapeProduct ? nameTapeProduct.price : 0;

    const hiddenInput = document.createElement('input');
    hiddenInput.type = 'hidden';
    hiddenInput.name = inputName;


    if(Object.keys(obj).length > 0){
      hiddenInput.value = `1,${Number(price).toFixed(2)},${nameTapePrice * Object.keys(obj).length},${JSON.stringify(obj)}`;
    }else{
      hiddenInput.value = `1,${Number(price).toFixed(2)},${nameTapePrice}}`;
    }

    // Now also include position at the end
    // hiddenInput.value = `1,${Number(price).toFixed(2)},${nameTapePrice},${sanitizeInput(nameText)},${sanitizeInput(position)}`;

    form.appendChild(hiddenInput);
  });
}


function showError(inputEl, message) {
  const errorDiv = document.createElement('div');
  errorDiv.textContent = message;
  errorDiv.className = "input-error-msg";
  errorDiv.style.color = "red";
  errorDiv.style.marginTop = "4px";
  errorDiv.style.fontSize = "14px";
  inputEl?.parentElement?.appendChild(errorDiv);
}

// Checkout functionality for name tape products
async function getCartItems() {
  try {
    const res = await fetch("/cart.json");
    const cart = await res.json();
    return cart?.items || [];
  } catch (error) {
    console.error("Error fetching cart:", error);
    return [];
  }
}

async function createDraftOrder(cartList, customNote) {
  const body = {
    shop: shop,
    note: customNote || "",
    lineItems: cartList,
  };

  try {
    const res = await fetch(`${serverPath}/api/create-draft-order`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(body),
    });

    const data = await res.json();
    if (data.invoiceUrl) {
      window.location.href = data.invoiceUrl;
    } else {
      console.error("Draft order creation failed", data);
    }
  } catch (error) {
    console.error("Draft order creation error:", error);
  }
}

async function processCheckout() {
  const cartItems = await getCartItems();
  // console.log(cartItems, "cartItems------->");

  const cartList = [];
  let customNote = "";

  cartItems?.forEach((item) => {
    const { properties, quantity, title, variant_id, final_price } = item;

    const isValidProperties =
      properties && typeof properties === "object" && Object.keys(properties).length > 0;
    const hasGidKey =
      isValidProperties && Object.keys(properties).some((key) => key.startsWith("_gid"));

    if (hasGidKey) {
      const lineCustomAttributes = [];

      for (const [key, value] of Object.entries(properties)) {
        const valueArr = value.split(",");
        // const [qtyStr, priceStr, namePrice, nameVal, positionVal] = valueArr;
        const [qtyStr, priceStr, namePrice] = valueArr;

        const addOn = Number(namePrice) || 0;
        const v = Number(qtyStr) || 1;
        
        const variantIdFromKey = key.split("_")[1];
        const variantId = variantIdFromKey.startsWith('gid://') 
          ? variantIdFromKey 
          : `gid://shopify/ProductVariant/${variantIdFromKey}`;

        const discountedBasePrice = final_price / 100;

        const mainItem = {
          quantity: quantity * v,
          variantId: variantId,
          priceOverride: {
            amount: discountedBasePrice + addOn,
            currencyCode,
          },
        };

        const jsonPart = value.slice(value.indexOf('{'));
        const obj = JSON.parse(jsonPart);
        
        const customAttributes = [];

        // Loop through the object
        for (let item in obj) {
          if (obj.hasOwnProperty(item)) {
            const kV = item === "1" ? "" : item;

            // Push Name
            customAttributes.push({
              key: `Name${kV}`,
              value: decodeHTMLEntities(obj[item].name)
            });

            // Push Position
            customAttributes.push({
              key: `Position${kV}`,
              value: decodeHTMLEntities(obj[item].selectValue)
            });
          }
        }

        // Utility function
        function decodeHTMLEntities(str) {
          const txt = document.createElement("textarea");
          txt.innerHTML = str;
          return txt.value;
        }


        if (Number(namePrice) !== 0) {
          const additionalPrice = Number(namePrice) * quantity;
          customAttributes.push({
            key: "Additional Charges",
            value: additionalPrice.toString(),
          });
        }

        // for (const [key, value] of Object.entries(JSON.par)){

        // }

        // if (nameVal) {
        //   customAttributes.push({
        //     key: "Name",
        //     value: decodeHTMLEntities(nameVal),
        //   });
        // }

        // if (positionVal) {
        //   customAttributes.push({
        //     key: "Position",
        //     value: decodeHTMLEntities(positionVal),
        //   });
        // }



        mainItem.customAttributes = customAttributes;

        // 🔹 Add attribute values to line-level custom note
        if (customAttributes.length > 0) {
          const attrValues = customAttributes.map(attr => `${attr.key}: ${attr.value}`).join("; ");
          lineCustomAttributes.push(`${title} [${attrValues}]`);
        } else {
          lineCustomAttributes.push(title);
        }

        cartList.push(mainItem);
      }

      // Append lineCustomAttributes to overall customNote
      customNote += (customNote ? ", " : "") + lineCustomAttributes.join(", ");

    } else {
      cartList.push({
        quantity,
        variantId: `gid://shopify/ProductVariant/${variant_id}`,
        priceOverride: {
          amount: final_price / 100,
          currencyCode,
        },
      });
    }
  });

  await createDraftOrder(cartList, customNote);
}


// Setup checkout button if it exists
document.addEventListener("DOMContentLoaded", () => {
  const checkoutBtn = document.querySelector('[name="checkout"]');
  // console.log("checkoutBtn",checkoutBtn)
  if (checkoutBtn) {
    checkoutBtn.addEventListener("click", async (e) => {
      e.preventDefault();
      
      checkoutBtn.textContent = "";
      checkoutBtn.style.pointerEvents = "none";
      
      const spinner = document.createElement("div");
      spinner.className = "gogna-custom-spinner";
      checkoutBtn.appendChild(spinner);

      try {
        // console.log("Welcome toooo ");
        
        await processCheckout();
      } catch (error) {
        console.error("Checkout failed:", error);
      } finally {
        spinner.remove();
        checkoutBtn.textContent = "Proceed to checkout";
        checkoutBtn.style.pointerEvents = "";
      }
    });
  }
});
